<button :type="type" v-html="text"></button>